import axios from 'axios';

export default function getImageById(id) {
    return new Promise((resolve, reject) => {
        if (id && id !== 0 && id !== '0') {
            axios.get('/api/media/image/' + id)
                .then(response => {
                    resolve(response.data.data.image);
                })
                .catch(() => {
                    reject('Image Not Found');
                });
        } else {
            reject('Image ID not provided.');
        }
    });
}
